<template>
  <div id="knowledge">
    <v-container grid-list-xl px-4>
      <v-layout align-center justify-center row wrap>
        <v-flex sm3 xs6>
          <v-img
            aspect-ratio="1"
            contain
            :lazy-src="require('@/assets/school/agripreneur.png')"
            :src="require('@/assets/school/agripreneur.png')"
          ></v-img>
        </v-flex>
      </v-layout>
      <v-layout align-center justify-center row wrap>
        <v-flex mb-4 sm6 text-xs-center xs12>
          <div class="headline font-weight-bold">{{ titleText }}</div>
          <div class="caption font-weight-bold mt-2">{{ captionText }}</div>
        </v-flex>
      </v-layout>
      <KnowldgeCard />
    </v-container>
  </div>
</template>

<script>
import KnowldgeCard from '@/components/knowledge/KnowledgeCard'
export default {
  name: 'knowledge',
  components: {
    KnowldgeCard
  },
  data() {
    return {
      titleText: `ศูนย์บ่มเพาะนักธุรกิจเกษตร`,
      captionText: `หน่วยงานบ่มเพาะและให้คำปรึกษาสำหรับนักธุรกิจเกษตรหรือผู้ตั้งใจริเริ่มทำธุรกิจ เกษตร
            ที่กำลังมองหาองค์ความรู้ เครื่องมือ และกรสนับสนุน เพื่อออกแบบและ
            ปรับปรุงธุรกิจเกษตรของตนให้ยั่งยืนยิ่งขึ้น`
    }
  }
}
</script>

<style lang="scss" scoped></style>
